export default {
  post: {},
  posts: [],
}
